import { MutationCache } from "@tanstack/react-query";
import { isRecord } from "src/lib/native-bridge/define-native-message";
import { NATIVE_MESSAGES, TNativeMessageMeta } from "src/lib/native-bridge/native-messages";
import { postMessageToNative } from "src/lib/native-bridge/post-message-to-native";

interface IPostNativeMessageForMutationParams {
    variables: unknown;
    nativeMessage?: TNativeMessageMeta;
}

export const postNativeMessageForMutation = ({ variables, nativeMessage }: IPostNativeMessageForMutationParams) => {
    if (!nativeMessage) {
        return;
    }

    const message = NATIVE_MESSAGES.find(({ type }) => type === nativeMessage.type);
    const payload = message?.parse({ ...(isRecord(variables) ? variables : {}), ...nativeMessage });
    if (!message || !payload) {
        return;
    }

    postMessageToNative({ type: message.type, ...payload });
};

export const createNativeSyncMutationCache = () =>
    new MutationCache({
        onSuccess: (_data, variables, _onMutateResult, mutation) => {
            postNativeMessageForMutation({ variables, nativeMessage: mutation.meta?.nativeMessage });
        },
    });
